import { countStreamStatusTypesForCampaign } from "./Streams";

export const CAMPAIGN_TIERS = {
    basic: {
        displayName: 'T3',
        dbString: 'basic',
        oldDBString: 'bronze',
        imgString: 't3',
    },
    custom: {
        displayName: 'Custom',
        dbString: 'custom',
        oldDBString: 'gold',
        imgString: 'customnew',
    },
}

export const CAMPAIGN_TIER_ORDER = [
    CAMPAIGN_TIERS.basic,
    CAMPAIGN_TIERS.custom
]

export const getCampaignTierDataFromDbString = (dbString) => {
    for (let i = 0; i < CAMPAIGN_TIER_ORDER.length; i++) {
        if (CAMPAIGN_TIER_ORDER[i].dbString === dbString || CAMPAIGN_TIER_ORDER[i].oldDBString === dbString ) {
            return CAMPAIGN_TIER_ORDER[i];
        }
    }
    return CAMPAIGN_TIERS.custom;
}

export const getCampaignTierFormData = (listArray = [], ignoreTiers = []) => {
    for (let i = 0; i < CAMPAIGN_TIER_ORDER.length; i++) {
        if (ignoreTiers.indexOf(CAMPAIGN_TIER_ORDER[i]) === -1 && ignoreTiers.indexOf(CAMPAIGN_TIER_ORDER[i].displayName) === -1 && ignoreTiers.indexOf(CAMPAIGN_TIER_ORDER[i].dbString) === -1) {
            listArray.push({id: CAMPAIGN_TIER_ORDER[i].dbString, value: CAMPAIGN_TIER_ORDER[i].dbString, label: CAMPAIGN_TIER_ORDER[i].displayName});
        }
    }
    return listArray;
}

export const campaignHasSalesforceNumber = (campaignData) => {
    const rawSfNumber = campaignData?.sfNumber;

    if (typeof rawSfNumber === 'number') {
        return rawSfNumber > 0;
    }

    if (typeof rawSfNumber === 'string') {
        const trimmedSfNumber = rawSfNumber.trim();
        if (!trimmedSfNumber) {
            return false;
        }

        const parsedSfNumber = Number(trimmedSfNumber);
        return Number.isFinite(parsedSfNumber) ? parsedSfNumber > 0 : true;
    }

    return false;
}

// d || ((sf&&Tw) && !cw)
// 0        0         0    0
// 0        0         1    0
// 0        1         0    1
// 0        1         1    0
// 1        0         0    1
// 1        0         1    1
// 1        1         0    1
// 1        1         1    1

//((!Sf&&Tw) && !cw) || (d && !cw)
//          0               0          0
//          0               1          1
//          0               0          0
//          0               0          0
//          1               0          1
//          1               1          1
//          0               0          0
//          0               0          0
//          0               0          0
//          0               1          1
//          0               0          0
//          0               0          0
//          0               0          0
//          0               1          1
//          0               0          0
//          0               0          0
export const shouldShowCampaignWatermark = (campaignData) => {
    if (!campaignData) {
        return false;
    }

    const doesCampaignHaveSalesforceNumber = campaignHasSalesforceNumber(campaignData);

    return (/*process.env.NODE_ENV === 'dev' ||*/ (!doesCampaignHaveSalesforceNumber && campaignData.platform !== "Twitch") && campaignData.clearWatermark === false) || (campaignData.draft === true && campaignData.clearWatermark === false);
}

export const orderCampaignsAccordingToStatus = (campaigns) => {
    // Order our campaigns, live is most important, then scheduled, then ended, probably needs some date ordering as well
    for (let i = 0; i < campaigns.length; i++) {
        const statusCounts = countStreamStatusTypesForCampaign(campaigns[i].streams);
        campaigns[i].statusCounts = statusCounts;
    }
    campaigns.sort((a, b) => {
        // Big numbers here! As long as we have less than 500 streams, the ended campaigns will always go at the end
        let aPriority = a.statusCounts.live * 1000000 + a.statusCounts.scheduled * 500 + a.statusCounts.ended;
        let bPriority = b.statusCounts.live * 1000000 + b.statusCounts.scheduled * 500 + b.statusCounts.ended;
        return bPriority - aPriority;
    });
    return campaigns;
}

export const findFeature = (featureId, campaignData) => {
    for (let i = 0; i < campaignData.features.length; i++) {
        if (campaignData.features[i]._id === featureId) {
            return campaignData.features[i];
        }
    }
    return null;
}

export const findFeatureByVarKey = (featureVarKey, campaignData) => {
    for (let i = 0; i < campaignData.features.length; i++) {
        if (campaignData.features[i].varKey && campaignData.features[i].varKey === featureVarKey) {
            return campaignData.features[i];
        }
    }
    return null;
}

export const findLinkedFeature = (featureId, campaignData, customisationData, basicOutput = false) => {
    const linkedFeatureNames = [];

    for (let i = 0; i < campaignData.chains.length; i++) {
        if (chainContainsFeature(campaignData.chains[i], featureId)) {
            if (!basicOutput) {
                linkedFeatureNames.push('FEATURE CHAIN');
            } else {
                linkedFeatureNames.push('Feature Chain');
            }
        }
    }

    
    for (let cId in customisationData) {
        for (let tab in customisationData[cId]) {
            for (let tabGroup in customisationData[cId][tab]) {
                for (let varGroup in customisationData[cId][tab][tabGroup]) {
                    for (let i = 0; i < customisationData[cId][tab][tabGroup][varGroup].length; i++) {
                        for (let prop in customisationData[cId][tab][tabGroup][varGroup][i]) {
                            if (typeof customisationData[cId][tab][tabGroup][varGroup][i][prop] === 'string' && customisationData[cId][tab][tabGroup][varGroup][i][prop].split(':')[0] === featureId) {
                                let linkedFeatureName = '';
                                for (let j = 0; j < campaignData.features.length; j++) {
                                    if (campaignData.features[j]._id === cId) {
                                        linkedFeatureName = campaignData.features[j].contentLabel + ' (' + campaignData.features[j].feature.featureName +')';
                                        
                                    }
                                }
                                linkedFeatureNames.push(basicOutput ? linkedFeatureName : linkedFeatureName + ': ' + cId);
                            }
                        }
                    }
                }
            }
        }
    }
    if (linkedFeatureNames.length) {
        return linkedFeatureNames.join(', ');
    }

    return basicOutput ? 'Unknown' : 'NOT FOUND (APPEARS UN-USED, MAYBE DELETE?)';
}

export const isFeatureLinked = (featureId, campaignData, customisationData) => {
    for (let i = 0; i < campaignData.chains.length; i++) {
        if (chainContainsFeature(campaignData.chains[i], featureId)) {
            return true;
        }
    }

    for (let cId in customisationData) {
        for (let tab in customisationData[cId]) {
            for (let tabGroup in customisationData[cId][tab]) {
                for (let varGroup in customisationData[cId][tab][tabGroup]) {
                    for (let i = 0; i < customisationData[cId][tab][tabGroup][varGroup].length; i++) {
                        for (let prop in customisationData[cId][tab][tabGroup][varGroup][i]) {
                            if (typeof customisationData[cId][tab][tabGroup][varGroup][i][prop] === 'string' && customisationData[cId][tab][tabGroup][varGroup][i][prop].split(':')[0] === featureId) {
                                return true;
                            }
                        }
                    }
                }
            }
        }
    }

    return false;
}

export const findLinkedFeatureTriggers = (featureId, campaignData, customisationData) => {
    const triggeredFeatures = [];
    const featureCustomisation = customisationData?.[featureId];

    if (!campaignData?.features || !featureCustomisation) {
        return triggeredFeatures;
    }

    for (let f_i = 0; f_i < campaignData.features.length; f_i++) {
        if (campaignData.features[f_i]._id !== featureId) {
            for (let tab in featureCustomisation) {
                for (let tabGroup in featureCustomisation[tab]) {
                    for (let varGroup in featureCustomisation[tab][tabGroup]) {
                        for (let i = 0; i < featureCustomisation[tab][tabGroup][varGroup].length; i++) {
                            for (let prop in featureCustomisation[tab][tabGroup][varGroup][i]) {
                                if (typeof featureCustomisation[tab][tabGroup][varGroup][i][prop] === 'string' && featureCustomisation[tab][tabGroup][varGroup][i][prop].split(':')[0] === campaignData.features[f_i]._id) {
                                    if (triggeredFeatures.indexOf(campaignData.features[f_i]) === -1) {
                                        triggeredFeatures.push(campaignData.features[f_i]);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    return triggeredFeatures;
}

export const findUnlinkedChainedFeatures = (campaignData, customisationData) => {
    const unlinkedChainedFeaturesList = [];
    for (let f_i = 0; f_i < campaignData.features.length; f_i++) {
        if (campaignData.features[f_i].isChained && !isFeatureLinked(campaignData.features[f_i]._id, campaignData, customisationData)) {
            unlinkedChainedFeaturesList.push(campaignData.features[f_i]._id);
        }
    }
    return unlinkedChainedFeaturesList;
}

export const deriveChainId = (chainIndex, campaignData = null) => {
    // const campaignData = campaignContext.campaignData;
    if (!campaignData) {
        return null;
    }
    if (chainIndex < 0 || chainIndex >= campaignData.chains.length || !campaignData.chains[chainIndex] || campaignData.chains[chainIndex].length === 0) {
        return null;
    }
    
    // Helper to extract featureId from either string or object format
    const getFeatureId = (chainItem) => {
        if (typeof chainItem === 'string') {
            return chainItem.split(':')[0];
        } else if (typeof chainItem === 'object' && chainItem.featureId) {
            return chainItem.featureId;
        }
        return null;
    };
    
    let derivedChainId = null;
    for (let j = 0; j < campaignData.chains[chainIndex].length; j++) {
        const featureId = getFeatureId(campaignData.chains[chainIndex][j]);
        if (!featureId) continue;
        
        for (let k = 0; k < campaignData.features.length; k++) {
            if (campaignData.features[k]._id === featureId) {
                // found the feature...
                if (campaignData.features[k].feature.featureType === 'feature') {
                    // found our chainId
                    derivedChainId = featureId + '_' + chainIndex;
                    break;
                }
            }
        }
        if (derivedChainId) {
            break;
        }
    }
    if (derivedChainId === null) {
        // not a feature type, so use the first one we find
        const firstFeatureId = getFeatureId(campaignData.chains[chainIndex][0]);
        derivedChainId = firstFeatureId ? firstFeatureId + '_' + chainIndex : null;
    }
    return derivedChainId;
}

// Helper function to check if a chain contains a specific featureId (handles both string and object formats)
export const chainContainsFeature = (chain, targetFeatureId) => {
    if (!chain || !Array.isArray(chain)) return false;
    return chain.some(item => {
        if (typeof item === 'string') {
            return item.split(':')[0] === targetFeatureId;
        } else if (typeof item === 'object' && item.featureId) {
            return item.featureId === targetFeatureId;
        }
        return false;
    });
};

export const findFeatureChatCommands = (featureId, campaignData) => {
    const chatCommands = [];
    for (let i = 0; i < campaignData.hashtagCommands.length; i++) {
        if (campaignData.hashtagCommands[i].featureID === featureId) {
            chatCommands.push(campaignData.hashtagCommands[i]);
        }
    }
    return chatCommands;
}
